enum IdPRoutes {
    IDP_ENTER = '/idp/enter',
    ENTER_BADGE = '/enter-badge',
    IDP_INITIALIZE = '/idp/initialize',
    PREHIRES_WELCOME = '/prehires-welcome'
}

export default IdPRoutes;
